<script setup lang="ts">
const props = defineProps<{
  title?: string
  tabs: Array<{ title: string; link: string }>
}>()
</script>


<template>
    <div class="w-full">
        <h2 class="text-[22px] text-[#1b325a ] mb-7">دسترسی‌ها</h2>
        <!-- Tabs  -->
        <Tabs :tabs="tabs" :isAdminPanel="true" class="mt-8">
            <template #actions>
                <slot name="actions" />
            </template>
        </Tabs>
    </div>
</template>
